export default "__VITE_ASSET__p9ugdP$o__"